<template>
  <div class="carousel__container">
    
    <div class="tech-slideshow-back ">
        <div class="title__vanish">Technologies</div>
  <div class="mover-1" :style="{ background: 'url(' + image + ')' }"></div>

</div>

  </div>
</template>

<style></style>

<script>
export default {
  name: "carousel",
    data() {
        return {
            image: './disturb.jpg',
            c_image: './assets/logo.png',
            c_image1: './assets/disturb.jpg',
        };
    },
};
</script>
<style lang="scss" scoped>
.carousel__container {
  margin-left: calc(100vw/10);
}
/*Under text*/
  .title__vanish {
    font-size: calc(100vw/10);
    font-weight: 900;   
    position: absolute;
    width: 100%;
    top: calc(-100vh/15);
    left: 0;
    background: rgb(0, 0, 0);
  mix-blend-mode:hard-light;
    color: #827b7b;
    z-index:1
  }
.tech-slideshow-back {
  height: calc(100vw/11);
 
  width: 100vw;
  margin: 0 calc(-100vw/90);
  position: relative;
  overflow: hidden;
  transform: translate3d(0, 0, 0);
}

.tech-slideshow-back  > .mover-1 {
  height: 200px; width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  transform: translate3d(0, 0, 0);
}
.tech-slideshow-back  .mover-1 {
  //animation: moveSlideshow 12s linear infinite;
  width: 100%;
}
.tech-slideshow-back  .mover-2 {
  opacity: 0;
  transition: opacity 0.5s ease-out;
  background-position: 0 -200px;
 // animation: moveSlideshow 15s linear infinite;
}
.tech-slideshow-back :hover .mover-2 {
  opacity: 1;
}

@keyframes moveSlideshow {
  100% { 
    transform: translateX(-66.6666%);  
  }
}

@media only screen and (max-width: 768px) {
  .carousel__container {
 display: none;
}
}
</style>